interface Props {
  pendingCount: number;
}

// Dimensões base reduzidas em 10% (56→50, 42→38)
const S = 38; // tamanho de cada post-it
const W = 50;
const H = 54;

export function PostitIcon({ pendingCount }: Props) {
  return (
    <div style={{ position: 'relative', width: W, height: H, cursor: 'pointer' }}>
      {/* Post-it rosa, inclinado -9° */}
      <div style={{
        position: 'absolute', bottom: 4, left: 2,
        width: S, height: S, borderRadius: 4,
        backgroundColor: '#F8A7C7',
        transform: 'rotate(-9deg)',
        boxShadow: '1px 2px 4px rgba(0,0,0,.20)',
      }} />
      {/* Post-it azul, inclinado +8° */}
      <div style={{
        position: 'absolute', bottom: 4, right: 2,
        width: S, height: S, borderRadius: 4,
        backgroundColor: '#93CEEF',
        transform: 'rotate(8deg)',
        boxShadow: '1px 2px 4px rgba(0,0,0,.20)',
      }} />
      {/* Post-it amarelo à frente, reto */}
      <div style={{
        position: 'absolute', bottom: 0, left: '50%', transform: 'translateX(-50%)',
        width: S, height: S, borderRadius: 4,
        backgroundColor: '#FFE16B',
        boxShadow: '2px 3px 7px rgba(0,0,0,.26)',
        display: 'flex', flexDirection: 'column', justifyContent: 'center',
        gap: 4, padding: '7px 8px',
      }}>
        {[0, 1, 2].map((i) => (
          <div key={i} style={{ height: 2, borderRadius: 1, backgroundColor: '#6b540055' }} />
        ))}
      </div>
      {/* Badge de pendentes */}
      {pendingCount > 0 && (
        <div style={{
          position: 'absolute', top: 0, right: 0,
          minWidth: 16, height: 16, borderRadius: 8,
          backgroundColor: '#ef4444',
          color: '#fff', fontSize: 9, fontWeight: 700,
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          padding: '0 3px', lineHeight: 1,
        }}>
          {pendingCount > 99 ? '99+' : pendingCount}
        </div>
      )}
    </div>
  );
}
